import React from 'react'
import { getMatches } from './../utils/api'
import { useState } from 'react'
import { useEffect } from 'react'
import Pagination from 'react-js-pagination'
import moment from 'moment'

function UserMatches() {
  const [matches, setMatches] = useState([])
  const [queryData, setQueryData] = useState({ currentPage: 1, totalPages: 1, search: '', status: '' })

  useEffect(() => {
    getMatchData()
  }, [queryData.currentPage])

  function pageChanged(page) {
    let temp = { ...queryData }
    let getUsersFlag = false
    if (temp.currentPage === 1 && page === 1) {
      getUsersFlag = true
    }
    temp.currentPage = page
    setQueryData(temp)
    if (getUsersFlag) {
      getMatchData()
    }
  }

  async function getMatchData() {
    try {
      let response = await getMatches(queryData)
      if (response) {
        let temp = []
        temp = response.data.matches
        temp.forEach((item) => {
          if (!item.users[0]) {
            item.users[0] = { firstName: 'User Deleted' }
          }
          if (!item.users[1]) {
            item.users[1] = { firstName: 'User Deleted' }
          }
          if (!item.activities[0]) {
            item.activities[0] = { activity: 'Activity Deleted' }
          }
          if (!item.activities[1]) {
            item.activities[1] = { activity: 'Activity Deleted' }
          }
        })
        setMatches(temp)
        let tempData = { ...queryData }
        tempData.totalPages = response.data.totalPages
        setQueryData(tempData)
      }
    } catch (err) {
      console.log(err)
    }
  }

  function inputValueChanged(event) {
    let temp = { ...queryData }
    temp[event.target.name] = event.target.value
    setQueryData(temp)
  }

  return (
    <div className="content">
      <div className="container-fluid">
        <div className="row">
          <div className="col-md-12">
            <form>
              <div className="form-row">
                <div className="form-group col-md-6">
                  <label htmlFor="inputEmail4">Name/Email/Phone</label>
                  <input type="text" className="form-control" value={queryData.search} name="search" onChange={inputValueChanged} />
                </div>
              </div>
              <button
                type="button"
                onClick={(e) => {
                  pageChanged(1)
                }}
                className="btn btn-primary"
              >
                Apply
              </button>
            </form>
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <div className="card card-plain table-plain-bg">
              <div className="card-header">
                <h4 className="card-title">Matches List - {queryData.totalPages}</h4>
                <p className="card-category">Matches done on your app by the users</p>
              </div>
              <div className="card-header"></div>
              <div className="card-body table-full-width table-responsive">
                <table className="table table-hover">
                  <thead>
                    <tr>
                      <th>S.No.</th>
                      <th>First User</th>
                      <th>Second User</th>
                      <th>Activity</th>
                      <th>Matched On</th>
                    </tr>
                  </thead>
                  <tbody>
                    {matches.map((item, index) => (
                      <tr key={index}>
                        <td>{index + 1}</td>
                        <td>{item.users[0].firstName}</td>
                        <td>{item.users[1].firstName}</td>
                        <td>
                          {item.activities[0].activity}/{item.activities[1].activity}
                        </td>
                        <td>{moment(item.createdAt).format('DD-MM-YYYY')}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <Pagination
              activePage={queryData.currentPage}
              itemsCountPerPage={10}
              totalItemsCount={queryData.totalPages}
              pageRangeDisplayed={5}
              itemClass="page-item"
              linkClass="page-link"
              onChange={pageChanged}
            />
          </div>
        </div>
      </div>
    </div>
  )
}

export { UserMatches }
